/**
 * Polyfills
 *
 * @see https://www.npmjs.com/package/es6-object-assign
 * @see https://www.npmjs.com/package/svgxuse
 *
 * @package Embark
 * @since   1.0.1
 */

import es6promise from 'es6-promise';
import es6objectassign from 'es6-object-assign';
import 'nodelist-foreach-polyfill';
import stickybits from 'stickybits';

es6promise.polyfill();
es6objectassign.polyfill();

/**
 * Sticky elements (IE support) with Stickybits.
 * Stickybits is a lightweight alternative to position: sticky polyfills.
 * It works perfectly for things like sticky headers.
 *
 * @reference: https://github.com/dollarshaveclub/stickybits
 */
stickybits('.sticky', { scrollEl: 'body' });

/**
 * Cross-browser requestAnimationFrame function.
 *
 * @since 1.0.1
 */
window.requestAnimationFrame = window.requestAnimationFrame
|| window.mozRequestAnimationFrame
|| window.webkitRequestAnimationFrame
|| window.msRequestAnimationFrame
|| function (f) { setTimeout(f, 1000 / 60); };
